var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55720",
    "data-name": "Group 55720",
    transform: "translate(-0.077 -0.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55411",
    "data-name": "Group 55411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_622",
    "data-name": "Ellipse 622",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0.077 0.391)",
    fill: "#1e1e1e",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_14_30",
    "data-name": "Component 14 \\u2013 30",
    transform: "translate(8.077 8.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17786",
    "data-name": "Rectangle 17786",
    width: 23,
    height: 22,
    transform: "translate(0 0.106)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-lock",
    transform: "translate(2.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85322",
    "data-name": "Path 85322",
    d: "M17.953,7.905V6.569a6.569,6.569,0,1,0-13.138,0V7.905A4.692,4.692,0,0,0,2,12.2V17.83a4.7,4.7,0,0,0,4.692,4.692h9.384a4.7,4.7,0,0,0,4.692-4.692V12.2A4.692,4.692,0,0,0,17.953,7.905ZM6.692,6.569a4.692,4.692,0,0,1,9.384,0v.938H6.692Zm12.2,11.261a2.815,2.815,0,0,1-2.815,2.815H6.692A2.815,2.815,0,0,1,3.877,17.83V12.2A2.815,2.815,0,0,1,6.692,9.384h9.384A2.815,2.815,0,0,1,18.892,12.2Z",
    transform: "translate(-2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85323",
    "data-name": "Path 85323",
    d: "M11.938,14a.938.938,0,0,0-.938.938v1.877a.938.938,0,0,0,1.877,0V14.938A.938.938,0,0,0,11.938,14Z",
    transform: "translate(-2.554 -0.862)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.43968ef4d8186323f3d9dfb31d7ba8a5.svg";
export { ForwardRef as ReactComponent };